import type { UserFeatures } from "@glide/app-description";

export const dynamsoftScannerNumUpdates = 5;

export function hasCustomKeyForDynamsoftScanner(features: UserFeatures | undefined): boolean {
    return typeof features?.dbrScannerHandshake === "string";
}
